import { CodeXml, X } from "lucide-react"
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../ui/alert-dialog"
import { AddTagsForm } from "./AddTagsForm"
import { useState } from "react"
import { MyTooltip } from "../MyTooltip"

interface IAddTagsDialogProps {
    appName: string
}

export const AddTagsDialog = ({ appName }: IAddTagsDialogProps) => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
            <AlertDialogTrigger asChild>
                <MyTooltip text="Adicionar tags">
                    <CodeXml onClick={() => setIsOpen(true)} />
                </MyTooltip>
            </AlertDialogTrigger>
            <AlertDialogContent className="w-4/5 rounded-xl sm:w-2/6 sm:h-1/3">
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex justify-between items-center px-2">
                        <span className="text-primary">
                            Informe chave e valor
                        </span>
                        <div>
                            <X onClick={() => setIsOpen(false)} className="text-muted-foreground cursor-pointer" />
                        </div>
                    </AlertDialogTitle>
                    <div className="w-full h-full flex">
                        <AddTagsForm appName={appName} setIsOpen={setIsOpen} />
                    </div>

                    <AlertDialogDescription></AlertDialogDescription>
                </AlertDialogHeader>
            </AlertDialogContent>
        </AlertDialog>
    )
}